import { cn } from 'src/lib/utils';
import { portalDs } from 'src/components/portal-design-system';
import { SettingsCachesSection } from '../components/settings-caches-section';

const SettingsTab = () => (
  <div className={cn(portalDs.page, 'h-full overflow-y-auto px-6 py-8 sm:px-10')}>
    <SettingsCachesSection />
  </div>
);

export default SettingsTab;
